import { publicSiteLocation } from 'config/Vars'

import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'

interface SignOutAndRedirectProps {
  preloadDemoLogin: boolean
  redirect_uri?: string | null
}

export async function signOutAndRedirect({
  preloadDemoLogin,
  redirect_uri,
}: SignOutAndRedirectProps) {
  const api = ApiClient()

  const logoutRedirect = redirect_uri && preloadDemoLogin ? redirect_uri : publicSiteLocation

  const logoutHref = await api.get('/sessions', {
    uri: logoutRedirect,
  })
  await api.del('/sessions')
  window.location.href = logoutHref.redirect_uri
}
